import React from "react";

import SvgMessageNotificationCircle from "@uui/MessageNotificationCircle";

import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import { Column } from "@rui/Stack";

const EmptyTable = ({
  Icon,
  title,
  subtext,
}: {
  Icon: typeof SvgMessageNotificationCircle;
  title: string;
  subtext: string;
}) => (
  <Column sx={{ p: 1, pt: 0 }}>
    <EmptyStateContainer>
      <EmptyStateIcon Icon={Icon} />
      <EmptyStateTitle>{title}</EmptyStateTitle>
      <EmptyStateSubtext>{subtext}</EmptyStateSubtext>
    </EmptyStateContainer>
  </Column>
);

export default EmptyTable;
